import request from '@/utils/request'


export function login(data) {
  return request({
    url: '/v2/public/customers/sms/login',
    method: 'post',
    data
  })
}

// 个人信息
export function getUser() {
  return request({
    url: '/v2/client/customers/users/profiles',
    method: 'get',
  })
}

// 设备
export function getDevices() {
  return request({
    url: '/v2/client/devices/',
    method: 'get',
  })
}

// 商品
export function getGoods(params) {
  return request({
    url: '/v2/client/goods',
    method: 'get',
    params
  })
}

// 兑换码列表
export function getTransactionOrders(params) {
  return request({
    url: '/v2/client/transaction-orders',
    method: 'get',
    params
  })
}

export function getVerification(data) {
  return request({
    url: '/v2/public/customers/sms/verification-codes',
    method: 'post',
    data
  })
}

export function emailLogin(data) {
  return request({
    url: '/v2/public/customers/email/login',
    method: 'post',
    data
  })
}

export function getEmailVerification(data) {
  return request({
    url: '/v2/public/customers/email/verification-codes',
    method: 'post',
    data
  })
}
// stripe公钥
export function getKey() {
  return request({
    url: '/v2/client/transactions-args',
    method: 'get',
  })
}

// 下单

export function getOrder(data) {
  return request({
    url: '/v2/client/initiate-an-order', 
    method: 'post',
    // headers: { "Content-Type": "application/json" },
    data
  })
}

// /v2/client/transaction-redeem-codes
export function getTransactionRedeemCodes(params) {
  return request({
    url: '/v2/client/transaction-redeem-codes',
    method: 'get',
    params
  })
}